
    const data = {"name":"src/core/icons/circle-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 20a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            